import React, { Component } from 'react'
import styled from 'styled-components'
import { Container } from 'styled-bootstrap-grid'
import scrollTo from 'animated-scroll-to'

import theme from 'ui/styles/theme'
import { Text } from 'ui/styles/utils'
import CircleArrow from 'ui/components/generic/CircleArrow'

const bottom = 140

const Wrapper = styled.section`
  position: relative;
  margin-top: ${props => props.theme.navHeight}px;
`

const Content = styled.div`
  height: calc(100vh - ${bottom}px - ${props => props.theme.navHeight}px);
  background: ${props => props.image ? `url(${props.image}) center / cover no-repeat` : 'none'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: ${props => props.image ? 0 : bottom}px;
`

const Title = styled(Text).attrs({ size: 'xxl', as: 'h1' })`
  color: ${props => props.image ? '#fff' : 'inherit'};
  font-weight: 200;
  z-index: 2;
`

const Background = styled.div`
  position: absolute;
  top: ${props => !props.image ? 0 : 'auto'};
  left: 0px;
  right: 0px;
  background-color: ${props => props.theme.colors.secondaryDarker};
  height: ${props => props.image ? `${bottom * 2}px` : 'auto'};
  bottom: 0;
  align-items: center;
  justify-content: center;
`

const Scroll = styled.div`
  display: flex;
  height: ${bottom}px;
  align-items: center;
  justify-content: center;

  svg {
    cursor: pointer;
  }
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
`

export default class Hero extends Component {
  render() {
    const {
      image,
      title
    } = this.props

    return (
      <Wrapper >
        <Background image={!!image} />
        <Container fluid>
          <Content image={image && image.sourceUrl}>
            <Title image={image}>{title}</Title>
            {image &&
              <Overlay />
            }
          </Content>

          <Scroll image={!!image}>
            <CircleArrow
              color={theme.colors.tones.darker}
              direction="down"
              onClick={() => scrollTo(document.querySelector('#module-1'), { offset: -theme.navHeight })}
            />
          </Scroll>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/PageHeader/index.js